// extracted by css-extract-rspack-plugin
export default {"label":"gukaddIBOh8nUTip","small":"FwULbieinncErRVV","medium":"GWDyFqWXigHFQPMK","truncate":"SEAMME6RiscDd2Ql"};